import { Flex,Table } from 'antd'
import React from 'react'
import classes from './expense.module.css'
import ExpenseAddReportEdit from './ExpenseAddReportEdit';
import ExpenseEditReportEdit from './ExpenseEditReportEdit';
import Copy from '../../cpn/Copy';
import StateTag from '../../cpn/StateTag';
import ExpenseCheck from './ExpenseCheck';
function ExpenseListReport(props) {
     // 格式化金额显示
     const formatCurrency = (text) => (
         <span>
             ￥{Number(text).toLocaleString('zh-CN', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
             })}
         </span>
     );

     // 基础列定义
     const columns = [
        {  
            dataIndex: 'index', 
            width: 42, 
            key: '序号' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },       
        { 
            title: '费用客户', 
            dataIndex: 'fy_kh_name', 
            width: 200, 
            key: 'fy_kh_name' ,
            render: (text, record) => {
                if(record.fy_state === '1'){
                    return  <ExpenseEditReportEdit
                                fy_id={record.fy_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                fy_bzd_id={record.fy_bzd_id}
                                fy_price={record.fy_price}
                                fy_content={record.fy_content}
                                fy_date={record.fy_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                fy_type_id={record.fy_type_id}
                                fy_type_name={record.fy_type_name}
                                fy_kh_id={record.fy_kh_id}
                                fy_kh_name={record.fy_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                fy_num={record.fy_num}
                                fy_amount={record.fy_amount}
                                fy_uid={record.fy_uid}
                                fy_state={record.fy_state}
                                fy_image_name={record.fy_image_name}
                                fy_image_file={record.fy_image_file}
                                dsbzd_id={props.dsbzd_id}
                                fy_name={record.fy_name}
                                fy_bm_id={record.fy_bm_id}
                                fy_bm_name={record.fy_bm_name}
                                fy_khyhzh_id={record.fy_khyhzh_id}
                                fy_khyhzh_name={record.fy_khyhzh_name}
                                fy_ctime={record.fy_ctime}
                            />
                }else{
                    return  <ExpenseCheck
                                type='button'
                                fy_id={record.fy_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                fy_bzd_id={record.fy_bzd_id}
                                fy_price={record.fy_price}
                                fy_content={record.fy_content}
                                fy_date={record.fy_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                fy_type_id={record.fy_type_id}
                                fy_type_name={record.fy_type_name}
                                fy_kh_id={record.fy_kh_id}
                                fy_kh_name={record.fy_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                fy_num={record.fy_num}
                                fy_amount={record.fy_amount}
                                fy_uid={record.fy_uid}
                                fy_state={record.fy_state}
                                fy_image_name={record.fy_image_name}
                                fy_image_file={record.fy_image_file}
                                dsbzd_id={props.dsbzd_id}
                                fy_name={record.fy_name}
                                fy_bm_id={record.fy_bm_id}
                                fy_bm_name={record.fy_bm_name}
                                fy_khyhzh_id={record.fy_khyhzh_id}
                                fy_khyhzh_name={record.fy_khyhzh_name}
                                fy_ctime={record.fy_ctime}
                            />
                }
            }
        },      
        { 
             title: '费用金额', 
             dataIndex: 'fy_amount', 
             width: 200, 
             key: 'fy_amount',
             render: (text) => <span style={{ color: '#3366cc' }}>{formatCurrency(text)}</span>
        },
        { 
            title: '备注', 
            dataIndex: 'fy_content', 
            key: 'fy_content',
            render: (text) => <Copy title={text}/>
        },                               
        {
            title: '状态',
            dataIndex: 'fy_state',
            width: 80,
            key: 'fy_state',
            render: (text) => <StateTag state={text} />
        },
        {
            title: '编号    ',
            dataIndex: 'fy_id',
            width: 60,
            key: 'fy_id',
            
            
        }
     ];

    return (
        <div>
            <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',color:'#3366cc'}}>费用单</div>
                {props.report_type === 'edit' ? <ExpenseAddReportEdit
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}                                                                           
                    dsbzd_date={props.dsbzd_date}
                    dsbzd_date_end={props.dsbzd_date_end}
                    dsbzd_danhao={props.dsbzd_danhao}
                    dsbzd_name={props.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={props.dsbzd_uid}
                    dsbzd_state={props.dsbzd_state}
                    dsbzd_bm_id={props.dsbzd_bm_id}
                    dsbzd_bm_name={props.dsbzd_bm_name}
                    dsbzd_dscp_id={props.dsbzd_dscp_id}
                    dsbzd_dscp_name={props.dsbzd_dscp_name}
                    dsbzd_kh_id={props.dsbzd_kh_id}
                    dsbzd_kh_name={props.dsbzd_kh_name}
                /> : null}                    
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={props.fy_data}
                columns={columns}
                pagination={false}
                style={{marginTop:'10px'}}
                size='small'
                rowKey="fy_id"                    
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);    
                    if(total>0){
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} key="summary-2" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={2} key="summary-3" colSpan={1}>
                                <span style={{color:'#3366cc'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} key="summary-4" colSpan={columns.length - 2} ></Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }
                    return null;
                }}
                locale={{
                    emptyText: '暂无费用单' // This will display text when the table is empty
                }}
            />
        </div>
    )
}

export default ExpenseListReport